import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 

 
class BlogInfoContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            blogs : [],
            blog_info : [],
            loading : 1 
        }
    }
 
    componentDidMount()
    {
         this.setState({loading:0});
       
    } 


    render()
    { 
        
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
    return (
        
        <div>
 
    
 <section className="blog-details section-space">
 <div className="container blogs-page">

                <div className="row gutter-y-60">
                    <div className="col-lg-8">
                        <div className="blog-details">
                            <div className="blog-card blog-card--four wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                                <div className="blog-card__image">
                                    <img src={this.props.blog.image} alt={this.props.blog.title} />
                                    <div className="blog-card__date"><span>{this.props.blog.created_date}</span> <span>{this.props.blog.created_month}</span></div> 
                                </div> 
                                <div className="blog-card__content">
                                    <ul className="list-unstyled blog-card__meta">
                                        <li><a href="#"><span className="fas fa-user"></span> by Admin</a></li>
                                         
                                    </ul> 
                                    <h3 className="blog-card__title">{this.props.blog.title}</h3>
                                    
                                    <div className="blog-card__content__inner">
                                        <p className="blog-card__text blog-card__text--1"><div dangerouslySetInnerHTML={{ __html: this.props.blog.description}} /> </p> 
                                    </div> 
                                </div> 
                            </div> 
                             
                        </div> 
 
                    </div> 
                    <div className="col-lg-4">
                        <div className="sidebar">
                            <aside className="widget-area">
                                 
                                <div className="sidebar__posts-wrapper sidebar__single">
                                    <h4 className="sidebar__title sidebar__posts-title">Latest blogs</h4> 
                                    <ul className="sidebar__posts list-unstyled">
                                   
                                    {this.props.blogs.map((blog, index) => (
                                   
                                   <li className="sidebar__posts__item">
                                            <div className="sidebar__posts__image">
                                            <img src={blog.image} alt={blog.title} />
                                            </div> 
                                            <div className="sidebar__posts__content">
                                               
                                                <h4 className="sidebar__posts__title"><Link to={`/blog-info/${blog.slug}`} >{blog.title}</Link></h4>
                                                <p className="sidebar__posts__meta"><Link to={`/blog-info/${blog.slug}`} >
                                                        <span className="icon-user"></span>
                                                        By Admin</Link></p>  
                                            </div> 
                                        </li> 
                                    ))}
                                    </ul> 
                                </div> 
                                
                            </aside>
                        </div> 
                    </div> 
                </div> 
            </div> 
        </section> 

        </div>
    );
}

}

export default BlogInfoContent;